module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-75.2acf513.woff2";